import React from "react";
import { Hero, PageContent } from "../../components";

function HardWare() {
  return (
    <div className="flex overflow-x-hidden overflow-y-hidden relative flex-col -z-10">
      <Hero title={"Hardware"}>
        Prototypes are the canvases where {" "}
        <span className="text-lg font-black text-RougePastel md:text-xl lg:text-2xl">
          ideas
        </span>{" "}
        come to life.
      </Hero>

      <PageContent>
        {`
Being able to illustrate our project thought a protype seemed like the easiest way to make our vision come across. Indeed, there aren’t any photobioreator that enables to conducts heat. In our project, it was a determining factor to be able to preserve, conduct and measuring heat. 

To that end, we created a working prototype displaying the global operating features of our system. 

The project is composed of three main components: 

- A) Photobioreactor encasing the algae and bacteria solution  

- B) Clean water tank in which we find the water being warmed up

- C) Thermal exchanger where the heat from one is transmitted to the other.


To make it we used a combination of techniques, from 3-D printing to laser cutting as well as using basic handiwork. You can find the open-access file on your GitLab ([link here](https://gitlab.igem.org/2023/software-tools/ionis-paris/-/tree/main/hardware?ref_type=heads)) 


<div class="image_frame">
    <img class="illustration big" src="https://static.igem.wiki/teams/4577/wiki/project/hardware/visu-hardware-2.png">
</div>


### Photobioreactor 

- 1) Being buried, we chose to add a sliding door to our prototype, aiming to easily display the inside of the tank while providing the absence of natural light inside, saying true to our concept.  

- 2) The window is made of plexiglass allowing anyone to see inside and get an idea of our project functionates. To ensure everything stayed in place we created slots inside the project main block allowing to have stability within the component as well as ensuring the absence of any leaks. 

- 3) One of the two main objectives of the project is the heat production, to maximize production of heat, insulate properly our system is crucial. To that end we chose to create a double sided photobioreactor allowing the insertion of insulant within. We selected cork for several reasons such as it low carbon footprint compared to other, its aspect as well as its cost and ease of access. The agitation of the microorganisms needs to be efficient as well as adapted to not injured them. To that end we chose to install a bubble agitator. In our prototype we used one originally made for aquariums, because they are small, reliable, and easy to get by. 

- 9) Light is indispensable to the algae growth, to fulfill that requirement we installed LED string light. They are ideal considering their low consumption as well as the absence of heat production from them which could hurt the microorganisms.  


### Heat exchanger 

- 4) Ensuring the heat transfer between both tank we created a heat transfer system. Maximizing the contact zone by creating loops inside the photobioreactor mimicking the aspect of an inductor. To ensure a sound structure we chose to bend a metal hanger, which we placed inside a soft plastic tube allowing a modulable structure to be put in place. 

- 8) To have a real installation aspect we also added copper tubes, they are the entry and exit points of wastewater into the photobioreactor. They are coupled with our filtration system. 

 
### Display case 

- 6) A solid structure is crucial to ensure our prototype is movable. We chose to create a  PVC display case protecting as well as stabilizing the pieces together. Including a shoutout to our partners as well, we engraved their logos onto the base.  


### Sensors 

- 7) To avoid waste, we simulated the placement of each sensors, they are placed to ensured they are protected, the wire being place inside the case. Inside the photobioreactor we have four of them. They ensure the monitoring of the environment viability, such as the level of O2 and CO2, the pH and the temperature. We also installed temperature sensor inside the clean water tank to be able to estimate the heat transferred.  

- 5) To ensure the waterproofing of the system we added electric connectors, they also allow an easy disassembly of the system if needed. 

 
### Conclusion 

We succesfully assembled our prototype by analyzing how it could be used for experimental purposes. However, we didn’t manage to have time to test it. However, we hope that this prototype will be useful for future iGEM team who would like to do similar heat production experiments.
        `}
      </PageContent>
    </div>
  );
}

export default HardWare;
